module.exports = __webpack_public_path__ + "img/recommendations-protect-tip.5e01ec70.svg";